import axios from 'axios';
import VelocidadLinealTotal from './VelocidadLinealTotal';
import React, { useEffect, useState } from 'react';
import { Container, Grid, Card, CardContent, Typography, Box, IconButton, Tooltip } from '@mui/material';
import { Thermostat, Opacity, FlashOn, Speed, TrendingUp, DarkMode, LightMode } from '@mui/icons-material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import io from 'socket.io-client';
import { useNavigate } from 'react-router-dom';
import { keyframes } from '@mui/system';
import LineChart from './LineChart';
import LineChart2 from './lineChart2';
import LineChart3 from './lineChart3';
import GraficaTemperaturaMachine9 from './GraficaTemperaturaMachine9';
import GraficaTemperaturaMachine10 from './GraficaTemperaturaMachine10';
import GraficaTemperaturaMachine11 from './GraficaTemperaturaMachine11';
import BarAcumuladoDia from './BarChartAcumuladoDia';
import AcumuladoMesTable from './AcumuladoMesTable';
import AcumuladoDiaTable from './BarParadasMaquina';
import BarAcumuladoAnual from './BarAcumuladoAnual';
import CircleProgress from './CircleProgress';
import ExpandableCard from './ExpandableCard';
import DonutMetrosPorTurno from './DonutMetrosPorTurno';
import TableroMachine12 from './TableroMachine12';
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://pochelo.online';
const socket = io(SOCKET_URL);

// Estado para parámetros por máquina (ahora desde BD)
const defaultParams = {
    minTemp: 0,
    maxTemp: 100,
    minHum: 0,
    maxHum: 100,
    minAmp: 0,
    maxAmp: 100,
    minRpm: 0,
    maxRpm: 100,
};

const Datos = () => {
    // Estado modo oscuro/claro
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('darkMode') !== 'false';
    });

    const toggleDarkMode = () => {
        setDarkMode(prev => {
            localStorage.setItem('darkMode', String(!prev));
            return !prev;
        });
    };

    // Paleta de colores según el modo
    const theme = {
        bg:          darkMode ? '#04091a' : '#f0f4f8',
        cardBg:      darkMode ? '#071525' : '#ffffff',
        cardBg2:     darkMode ? '#050e1e' : '#e8edf2',
        text:        darkMode ? '#B8F1FF' : '#1a2b3c',
        textMuted:   darkMode ? '#3a5a80' : '#6b7280',
        textSub:     darkMode ? '#8ab0cc' : '#4b5563',
        border:      darkMode ? 'rgba(30, 90, 180, 0.55)' : '#d1d5db',
        borderCard:  darkMode ? 'rgba(40, 120, 255, 0.28)' : 'rgba(0,0,0,0.1)',
        // Relieve externo: Card elevada sobre el fondo
        shadow: darkMode
            ? '0 8px 32px rgba(0,0,0,0.85), 0 2px 8px rgba(0,0,0,0.6), inset 0 1px 0 rgba(60,140,255,0.18), inset 0 -2px 0 rgba(0,0,0,0.55)'
            : '0 4px 16px rgba(0,0,0,0.1), 0 1px 4px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.95)',
        // Relieve interno: área hundida dentro de la card
        shadowInset: darkMode
            ? 'inset 0 3px 12px rgba(0,0,0,0.75), inset 0 1px 4px rgba(0,0,0,0.6), inset 0 0 0 1px rgba(0,0,50,0.4)'
            : 'inset 0 2px 6px rgba(0,0,0,0.07)',
    };

    // Estado para parámetros de máquinas desde BD
    const [parametrosMaquinas, setParametrosMaquinas] = useState({});

    // Estado para acumuladoRPM de Machine8
    const [acumuladoRPM8, setAcumuladoRPM8] = useState(0);

    // Estado para temperaturas en tiempo real de Machine9, 10 y 11
    const [temperaturasRealTime, setTemperaturasRealTime] = useState({
        Machine9: null,
        Machine10: null,
        Machine11: null
    });

    // Estado para amperajes en tiempo real de Machine9, 10 y 11
    const [amperajesRealTime, setAmperajesRealTime] = useState({
        Machine9: null,
        Machine10: null,
        Machine11: null
    });

    // Obtener acumuladoRPM de Machine8 al montar el componente
    useEffect(() => {
        const fetchAcumulado = async () => {
            try {
                const res = await axios.get('/machine8/acumulado');
                setAcumuladoRPM8(res.data.acumuladoRPM || 0);
            } catch (err) {
                setAcumuladoRPM8(0);
            }
        };
        fetchAcumulado();
    }, []);

    // Cargar parámetros de máquinas desde la BD
    useEffect(() => {
        const fetchParametros = async () => {
            try {
                const response = await fetch('/api/maquinas-parametros');
                const data = await response.json();

                // Convertir a un mapa: Machine1 -> parametros
                const parametrosPorNombre = {};
                if (data.maquinas && data.parametros) {
                    data.maquinas.forEach(maquina => {
                        const nombreMaquina = maquina.machineNumber || maquina.nombre;
                        const parametrosObj = data.parametros[maquina._id];
                        if (nombreMaquina && parametrosObj) {
                            parametrosPorNombre[nombreMaquina] = parametrosObj;
                        }
                    });
                }
                setParametrosMaquinas(parametrosPorNombre);
            } catch (error) {
                console.error('Error al cargar parámetros de máquinas:', error);
            }
        };

        fetchParametros();

        // Escuchar cambios en los parámetros
        const handleParametrosActualizados = () => {
            fetchParametros();
        };
        window.addEventListener('parametrosMaquinasActualizados', handleParametrosActualizados);

        return () => {
            window.removeEventListener('parametrosMaquinasActualizados', handleParametrosActualizados);
        };
    }, []);

    const [machineData, setMachineData] = useState(() => {
        try {
            const savedData = localStorage.getItem('machineData');
            return savedData ? JSON.parse(savedData) : [];
        } catch (error) {
            console.error('Error al cargar datos desde localStorage:', error);
            return [];
        }
    });

    // Última actualización por máquina (persistida en localStorage)
    const [machineLastUpdates, setMachineLastUpdates] = useState(() => {
        try {
            const saved = localStorage.getItem('machineLastUpdates');
            return saved ? JSON.parse(saved) : {};
        } catch (e) {
            return {};
        }
    });

    // Estado para acumulados del día por máquina (de BarChartAcumuladoDia)
    const [acumuladosDia, setAcumuladosDia] = useState({});

    const blink = keyframes`
    0% { opacity: 1; }
    50% { opacity: 0.2; }
    100% { opacity: 1; }
  `;

    // Función para obtener el color según el valor y parámetros de cada máquina
    const getTempColor = (valor, params) => {
        if (valor < params.minTemp) return '#93C5FD';
        if (valor > params.maxTemp) return { color: 'rgba(33, 119, 218, 1)', animation: `${blink} 0.5s infinite` };
        return '#a8b2b4ff';
    };
    const getHumColor = (valor, params) => {
        if (valor < params.minHum) return '#f02323ff';
        if (valor > params.maxHum) return { color: 'rgba(59,130,246,1)', animation: `${blink} 0.5s infinite` };
        return '#5f5d5dff';
    };
    const getAmpColor = (valor, params) => {
        if (valor < params.minAmp) return '#111111';
        if (valor > params.maxAmp) return { color: 'rgba(225, 116, 15, 1)', animation: `${blink} 0.5s infinite` };
        return '#5f5d5dff';
    };
    const getRpmColor = (valor, params) => {
        if (valor < params.minRpm) return { color: 'rgba(225, 116, 15, 1)', animation: `${blink} 0.5s infinite` };
        if (valor > params.maxRpm) return { color: 'rgba(60, 228, 60, 1)' };
        return '#5f5d5dff';
    };
    // Color plano para el arco del progreso circular de RPM
    const getRpmArcColor = (valor, params) => {
        if (valor < params.minRpm) return 'rgba(225, 116, 15, 1)';
        if (valor > params.maxRpm) return 'rgba(60, 228, 60, 1)';
        return '#B8F1FF';
    };

    const navigate = useNavigate();

    // Guardar en localStorage cuando los datos cambien
    useEffect(() => {
        try {
            localStorage.setItem('machineData', JSON.stringify(machineData));
            localStorage.setItem('machineLastUpdates', JSON.stringify(machineLastUpdates));
        } catch (error) {
            console.error('Error al guardar en localStorage:', error);
        }
    }, [machineData]);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
            return;
        }

        const handleConnect = () => {
            console.log('Conectado a socket.io');
            socket.emit('solicitarUltimoAcumuladoHoy');
        };
        const handleDisconnect = () => {
            console.log('Desconectado de socket.io');
        };
        socket.on('connect', handleConnect);
        socket.on('disconnect', handleDisconnect);

        const handleMqttData = (socketReceivedData) => {
            // Log para depuración: ver si llegan datos de las máquinas 1-4
            if (/^Machine[1-4]$/.test(socketReceivedData.maquinaId)) {
                console.log('[SOCKET][1-4] Datos recibidos:', socketReceivedData);
            }
            setMachineData(prevData => {
                const machineExists = prevData.some(
                    machine => machine.maquinaId === socketReceivedData.maquinaId
                );

                const updatedLectura = {
                    temperatura: socketReceivedData.temperatura,
                    humedad: socketReceivedData.humedad,
                    amperaje: socketReceivedData.amperaje,
                    rpm: socketReceivedData.rpm,
                    acumuladoRPM: socketReceivedData.acumuladoRPM ?? (machineExists ? (prevData.find(m => m.maquinaId === socketReceivedData.maquinaId)?.lecturas[0]?.acumuladoRPM || 0) : 0),
                    eficiencia: ((socketReceivedData.rpm || 0) / 35) * 100,
                    fecha: new Date().toISOString()
                };

                if (machineExists) {
                    return prevData.map(machine => {
                        if (machine.maquinaId === socketReceivedData.maquinaId) {
                            const updatedLecturas = [updatedLectura];
                            if (machine.lecturas && machine.lecturas.length > 0) {
                                updatedLecturas.push(...machine.lecturas.slice(0, 9));
                            }
                            return {
                                ...machine,
                                lecturas: updatedLecturas,
                                ultimaActualizacion: new Date().toISOString()
                            };
                        }
                        return machine;
                    });
                } else {
                    const newMachine = {
                        maquinaId: socketReceivedData.maquinaId,
                        lecturas: [updatedLectura],
                        ultimaActualizacion: new Date().toISOString()
                    };
                    return [...prevData, newMachine];
                }
            });
            // Registrar última actualización para esta máquina
            setMachineLastUpdates(prev => {
                const copy = { ...prev };
                copy[socketReceivedData.maquinaId] = new Date().toISOString();
                try {
                    localStorage.setItem('machineLastUpdates', JSON.stringify(copy));
                } catch (e) {
                    console.warn('No se pudo guardar machineLastUpdates en localStorage', e);
                }
                return copy;
            });
        };

        socket.on('mqttData', handleMqttData);
        socket.on('mqttData2', handleMqttData);

        const handleUltimoAcumulado = (result) => {
            const dict = {};
            result.forEach(item => {
                dict[item.dispositivoId] = item.avanceRPM || 0;
            });
            setAcumuladosDia(dict);
        };
        socket.on('ultimoAcumuladoHoy', handleUltimoAcumulado);
        socket.emit('solicitarUltimoAcumuladoHoy');

        // NUEVO: Listener para Machine8
        const handleMachine8Data = (data) => {
            // Log para depuración: ver datos recibidos para Machine8
            console.log('[SOCKET][Machine8] Datos recibidos:', data);

            // Actualizar acumuladoRPM8 si viene en los datos
            if (typeof data.acumuladoRPM === 'number') {
                setAcumuladoRPM8(data.acumuladoRPM);
            }

            setMachineData(prevData => {
                const machineExists = prevData.some(
                    machine => machine.maquinaId === data.maquinaId
                );

                if (machineExists) {
                    return prevData.map(machine => {
                        if (machine.maquinaId === data.maquinaId) {
                            const updatedLectura = {
                                // Seis temperaturas
                                temperatura1: data.temperatura1,
                                temperatura2: data.temperatura2,
                                temperatura3: data.temperatura3,
                                temperatura4: data.temperatura4,
                                temperatura5: data.temperatura5,
                                temperatura6: data.temperatura6,
                                // Otros datos
                                humedad: data.humedad,
                                amperaje: data.amperaje,
                                velocidadLineal: data.velocidadLineal,
                                // Nuevo: acumuladoRPM
                                acumuladoRPM: data.acumuladoRPM ?? 0,
                                fecha: new Date().toISOString()
                            };
                            const updatedLecturas = [updatedLectura];
                            if (machine.lecturas && machine.lecturas.length > 0) {
                                updatedLecturas.push(...machine.lecturas.slice(0, 9));
                            }
                            return {
                                ...machine,
                                lecturas: updatedLecturas,
                                ultimaActualizacion: new Date().toISOString()
                            };
                        }
                        return machine;
                    });
                } else {
                    const newMachine = {
                        maquinaId: data.maquinaId,
                        lecturas: [{
                            temperatura1: data.temperatura1,
                            temperatura2: data.temperatura2,
                            temperatura3: data.temperatura3,
                            temperatura4: data.temperatura4,
                            temperatura5: data.temperatura5,
                            temperatura6: data.temperatura6,
                            humedad: data.humedad,
                            amperaje: data.amperaje,
                            velocidadLineal: data.velocidadLineal,
                            // Nuevo: acumuladoRPM
                            acumuladoRPM: data.acumuladoRPM ?? 0,
                            fecha: new Date().toISOString()
                        }],
                        ultimaActualizacion: new Date().toISOString()
                    };
                    return [...prevData, newMachine];
                }
            });
            // Registrar última actualización para machine8
            setMachineLastUpdates(prev => {
                const copy = { ...prev };
                copy[data.maquinaId] = new Date().toISOString();
                try {
                    localStorage.setItem('machineLastUpdates', JSON.stringify(copy));
                } catch (e) {
                    console.warn('No se pudo guardar machineLastUpdates en localStorage', e);
                }
                return copy;
            });
        };

        socket.on('mqttMachine8', handleMachine8Data);

        // Escuchar eventos de Machine9, 10 y 11 para actualizar temperaturas y amperajes en tiempo real
        socket.on('mqttMachine9', (data) => {
            console.log('[SOCKET][Machine9] Datos recibidos:', data);
            console.log('[SOCKET][Machine9] Amperaje:', data.amperaje);
            if (data.temperatura1 !== undefined) {
                setTemperaturasRealTime(prev => {
                    console.log('[Machine9] Actualizando temperatura:', data.temperatura1);
                    return { ...prev, Machine9: data.temperatura1 };
                });
            }
            if (data.amperaje !== undefined) {
                setAmperajesRealTime(prev => {
                    console.log('[Machine9] Actualizando amperaje:', data.amperaje);
                    return { ...prev, Machine9: data.amperaje };
                });
            }

            // Guardar lectura completa en machineData
            setMachineData(prevData => {
                const machineExists = prevData.some(m => m.maquinaId === 'Machine9');
                const updatedLectura = {
                    temperatura1: data.temperatura1,
                    amperaje: data.amperaje,
                    humedad: data.humedad,
                    velocidadLineal: data.velocidadLineal,
                    acumuladoRPM: data.acumuladoRPM ?? 0,
                    fecha: new Date().toISOString()
                };

                if (machineExists) {
                    return prevData.map(machine => {
                        if (machine.maquinaId === 'Machine9') {
                            const updatedLecturas = [updatedLectura, ...machine.lecturas.slice(0, 9)];
                            return {
                                ...machine,
                                lecturas: updatedLecturas,
                                ultimaActualizacion: new Date().toISOString()
                            };
                        }
                        return machine;
                    });
                } else {
                    return [...prevData, {
                        maquinaId: 'Machine9',
                        lecturas: [updatedLectura],
                        ultimaActualizacion: new Date().toISOString()
                    }];
                }
            });
        });

        socket.on('mqttMachine10', (data) => {
            console.log('[SOCKET][Machine10] Datos recibidos:', data);
            if (data.temperatura1 !== undefined) {
                setTemperaturasRealTime(prev => ({ ...prev, Machine10: data.temperatura1 }));
            }
            if (data.amperaje !== undefined) {
                setAmperajesRealTime(prev => ({ ...prev, Machine10: data.amperaje }));
            }

            // Guardar lectura completa en machineData
            setMachineData(prevData => {
                const machineExists = prevData.some(m => m.maquinaId === 'Machine10');
                const updatedLectura = {
                    temperatura1: data.temperatura1,
                    amperaje: data.amperaje,
                    humedad: data.humedad,
                    velocidadLineal: data.velocidadLineal,
                    acumuladoRPM: data.acumuladoRPM ?? 0,
                    fecha: new Date().toISOString()
                };

                if (machineExists) {
                    return prevData.map(machine => {
                        if (machine.maquinaId === 'Machine10') {
                            const updatedLecturas = [updatedLectura, ...machine.lecturas.slice(0, 9)];
                            return {
                                ...machine,
                                lecturas: updatedLecturas,
                                ultimaActualizacion: new Date().toISOString()
                            };
                        }
                        return machine;
                    });
                } else {
                    return [...prevData, {
                        maquinaId: 'Machine10',
                        lecturas: [updatedLectura],
                        ultimaActualizacion: new Date().toISOString()
                    }];
                }
            });
        });

        socket.on('mqttMachine11', (data) => {
            console.log('[SOCKET][Machine11] Datos recibidos:', data);
            if (data.temperatura1 !== undefined) {
                setTemperaturasRealTime(prev => ({ ...prev, Machine11: data.temperatura1 }));
            }
            if (data.amperaje !== undefined) {
                setAmperajesRealTime(prev => ({ ...prev, Machine11: data.amperaje }));
            }

            // Guardar lectura completa en machineData
            setMachineData(prevData => {
                const machineExists = prevData.some(m => m.maquinaId === 'Machine11');
                const updatedLectura = {
                    temperatura1: data.temperatura1,
                    amperaje: data.amperaje,
                    humedad: data.humedad,
                    velocidadLineal: data.velocidadLineal,
                    acumuladoRPM: data.acumuladoRPM ?? 0,
                    fecha: new Date().toISOString()
                };

                if (machineExists) {
                    return prevData.map(machine => {
                        if (machine.maquinaId === 'Machine11') {
                            const updatedLecturas = [updatedLectura, ...machine.lecturas.slice(0, 9)];
                            return {
                                ...machine,
                                lecturas: updatedLecturas,
                                ultimaActualizacion: new Date().toISOString()
                            };
                        }
                        return machine;
                    });
                } else {
                    return [...prevData, {
                        maquinaId: 'Machine11',
                        lecturas: [updatedLectura],
                        ultimaActualizacion: new Date().toISOString()
                    }];
                }
            });
        });

        return () => {
            socket.off('connect', handleConnect);
            socket.off('disconnect', handleDisconnect);
            socket.off('mqttData', handleMqttData);
            socket.off('mqttData2', handleMqttData);
            socket.off('ultimoAcumuladoHoy', handleUltimoAcumulado);
            socket.off('mqttMachine8', handleMachine8Data);
            socket.off('mqttMachine9');
            socket.off('mqttMachine10');
            socket.off('mqttMachine11');
        };
    }, [navigate]);

    // Filtrar solo para asegurar que las máquinas tienen el formato correcto
    // Para depuración, mostrar todos los datos recibidos
    console.log('DEBUG: machineData sin filtrar', machineData);

    // Lista de máquinas esperadas (ajusta según tus dispositivos)
    const expectedMachines = ['Machine1', 'Machine2', 'Machine3', 'Machine4', 'Machine5', 'Machine6', 'Machine7', 'Machine8', 'Machine9', 'Machine10', 'Machine11'];

    // Construir un mapa por maquinaId para acceso rápido
    const machineMap = {};
    machineData.forEach(m => {
        machineMap[m.maquinaId] = m;
    });

    // Generar lista final de máquinas a mostrar, respetando el orden expectedMachines
    const sortedData = expectedMachines.map(id => {
        if (machineMap[id]) return machineMap[id];
        // placeholder si no existe
        return { maquinaId: id, lecturas: [] };
    });

    // Formateador simple HH:MM a partir de ISO
    const formatHour = (iso) => {
        if (!iso) return null;
        try {
            const d = new Date(iso);
            const h = String(d.getHours()).padStart(2, '0');
            const m = String(d.getMinutes()).padStart(2, '0');
            return `${h}:${m}`;
        } catch (e) { return null; }
    };

    // Determina si una lectura contiene al menos un valor numérico válido
    const isValidLectura = (lect) => {
        if (!lect || typeof lect !== 'object') return false;
        if (Object.keys(lect).length === 0) return false;
        const numericFields = ['temperatura', 'humedad', 'amperaje', 'rpm', 'velocidadLineal', 'acumuladoRPM', 'temperatura1', 'temperatura2', 'temperatura3', 'temperatura4', 'temperatura5', 'temperatura6'];
        const isNumeric = (v) => {
            if (v === null || v === undefined) return false;
            // Aceptar números o strings que representen números (evitar strings vacíos)
            if (typeof v === 'number') return Number.isFinite(v);
            if (typeof v === 'string') {
                const s = v.trim();
                if (s === '') return false;
                return !Number.isNaN(Number(s));
            }
            return false;
        };
        return numericFields.some(f => isNumeric(lect[f]));
    };

    return (
        <Container maxWidth={false} sx={{ width: '99%', px: { xs: 0, sm: 2 }, '@media (min-width: 1441px)': { width: '90%', mx: 'auto' }, backgroundColor: theme.bg, minHeight: '100vh', transition: 'background-color 0.3s' }}>
            {/* Botón toggle dark/light */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1, pr: 1 }}>
                <Tooltip title={darkMode ? 'Modo claro' : 'Modo oscuro'}>
                    <IconButton
                        onClick={toggleDarkMode}
                        sx={{
                            backgroundColor: darkMode ? '#0d1f3a' : '#dbeafe',
                            color: darkMode ? '#B8F1FF' : '#1d4ed8',
                            border: `1px solid ${darkMode ? '#1e4a80' : '#93c5fd'}`,
                            boxShadow: darkMode ? '0 2px 8px rgba(0,0,0,0.5), inset 0 1px 0 rgba(80,160,255,0.1)' : 'none',
                            '&:hover': { backgroundColor: darkMode ? '#142a4d' : '#bfdbfe' },
                            transition: 'all 0.3s',
                        }}
                    >
                        {darkMode ? <LightMode /> : <DarkMode />}
                    </IconButton>
                </Tooltip>
            </Box>
            <Box sx={{ mt: 1, color: theme.text, textAlign: 'center', overflow: 'hidden' }}>
                {/* Nota: eliminamos el mensaje global para que los placeholders por tarjeta sean el indicativo principal cuando no hay datos */}
                <Grid container spacing={1}>
                    {/* Tableros de máquinas: en desktop md=4, en móvil full width */}
                    <Grid item xs={12} md={4}>
                        <Grid container spacing={1} alignItems="stretch">
                            {sortedData.map((data) => {
                                const params = parametrosMaquinas[data.maquinaId] || defaultParams;
                                // Valor acumulado del día por máquina desde socket
                                const acumuladoDiaMaquina = acumuladosDia[data.maquinaId];
                                // Seguridad: determinar si hay lecturas y coger la primera lectura
                                const hasLecturas = Array.isArray(data.lecturas) && data.lecturas.length > 0 && isValidLectura(data.lecturas[0]);
                                const lect = hasLecturas ? data.lecturas[0] : {};
                                // Estilo para humedad: puede ser string o un objeto con color+animation
                                const _humStyle = getHumColor(lect.humedad, params);
                                const humTextStyle = (typeof _humStyle === 'string')
                                    ? { color: _humStyle }
                                    : { color: (_humStyle && _humStyle.color) ? _humStyle.color : '#a2aab4', ...(_humStyle && _humStyle.animation ? { animation: _humStyle.animation } : {}) };
                                const humIconColor = (typeof _humStyle === 'string') ? _humStyle : ((_humStyle && _humStyle.color) ? _humStyle.color : '#a2aab4');
                                const humIconSx = { color: humIconColor, fontSize: 20, ...(_humStyle && _humStyle.animation ? { animation: _humStyle.animation } : {}) };
                                if (data.maquinaId === 'Machine8') {
                                    // Usar el acumuladoRPM8 del endpoint para la barra de progreso
                                    return (
                                        <Grid item xs={6} key={data.maquinaId}>
                                            <ExpandableCard modalWidth={{ xs: '45vw', md: '20vw' }} modalHeight={{ xs: '45vw', md: '20vw' }}>
                                                <Card sx={{ backgroundColor: theme.cardBg, color: theme.text, minHeight: 200, display: 'flex', flexDirection: 'column', boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                                                    {/* Hacemos que CardContent use todo el alto y distribuya el contenido para que la tarjeta tenga la misma altura visual que las demás */}
                                                    <CardContent sx={{ p: { xs: 0.25, sm: 1 }, pb: { xs: 0.25, sm: 1 }, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                                        <Typography variant="h7" component="div" sx={{ borderBottom: `1px solid ${theme.border}`, pb: 0.5, mb: 0.5, color: theme.text, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                            <Box component="span" sx={{ fontSize: { xs: '0.6rem', sm: '0.7rem' }, fontWeight: 'bold' }}>{data.maquinaId}</Box>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, justifyContent: 'center' }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <TrendingUp sx={{ color: '#B8F1FF', fontSize: { xs: 12, sm: 14 } }} />
                                                                    <Box component="span" sx={{ fontSize: { xs: '0.6rem', sm: '0.7rem' }, color: '#B8F1FF', ml: 0.25 }}>
                                                                        {Math.round(((lect.velocidadLineal || 0) / 35) * 100)}%
                                                                    </Box>
                                                                </Box>
                                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <FlashOn sx={{ color: '#FFD700', fontSize: { xs: 12, sm: 14 } }} />
                                                                    <Box component="span" sx={{ fontSize: { xs: '0.6rem', sm: '0.7rem' }, color: '#d5d6d6ff', ml: 0.25 }}>
                                                                        {hasLecturas && lect.amperaje !== undefined ? `${lect.amperaje}A` : '-'}
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Typography>
                                                        {hasLecturas ? (
                                                            <>
                                                                {/* Contenedor principal: solo los 2 círculos (Amp + VelLineal) */}
                                                                <Box sx={{ flex: '1 1 auto', display: 'flex', gap: 1, alignItems: 'center', mt: 2 }}>
                                                                    <Box sx={{ border: `1px solid ${theme.borderCard}`, borderRadius: '6px', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 0.125, sm: 1 }, width: '50%', minWidth: 64, minHeight: { xs: 64, sm: 72 }, gap: 1 }}>
                                                                        <FlashOn sx={{ color: getAmpColor(lect.amperaje, params), fontSize: { xs: 18, sm: 20 }, flexShrink: 0 }} />
                                                                        <CircleProgress value={Number(lect.amperaje) || 0} min={params.minAmp} max={params.maxAmp} size={60} strokeWidth={5} bgColor="transparent" textColor="#a2aab4" progressColor="#B8F1FF" displayText={`${Number(lect.amperaje) || 0}A`} />
                                                                    </Box>
                                                                    <Box sx={{ border: `1px solid ${theme.borderCard}`, borderRadius: '6px', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, display: 'flex', alignItems: 'center', justifyContent: 'center', p: { xs: 0.125, sm: 1 }, width: '50%', minWidth: 64, minHeight: { xs: 64, sm: 72 }, gap: 1 }}>
                                                                        <Speed sx={{ color: getRpmArcColor(lect.rpm, params), fontSize: { xs: 18, sm: 20 }, flexShrink: 0 }} />
                                                                        <CircleProgress value={Number(lect.velocidadLineal) || 0} min={0} max={100} size={60} strokeWidth={5} bgColor="transparent" textColor="#a2aab4" progressColor="#B8F1FF" displayText={`${Number(lect.velocidadLineal) || 0} R`} />
                                                                    </Box>
                                                                </Box>
                                                            </>
                                                        ) : (
                                                            <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <Box sx={{ textAlign: 'center' }}>
                                                                    <Typography variant="h6" sx={{ color: '#adababff' }}>Sin datos - {data.maquinaId}</Typography>
                                                                    {machineLastUpdates[data.maquinaId] ? (
                                                                        <Typography variant="caption" sx={{ color: '#7f7f7f', display: 'block', mt: 0.5 }}>
                                                                            {`(última: ${formatHour(machineLastUpdates[data.maquinaId])})`}
                                                                        </Typography>
                                                                    ) : null}
                                                                </Box>
                                                            </Box>
                                                        )}
                                                        {/* Franja inferior: 6 temperaturas + acumulado circular */}
                                                        <Box sx={{ width: '100%', backgroundColor: theme.cardBg2, borderRadius: '0 0 8px 8px', p: { xs: 0.5, sm: 0.75 }, mt: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5, borderTop: `1px solid ${theme.borderCard}`, boxShadow: theme.shadowInset }}>
                                                            {/* 6 temperaturas compactas */}
                                                            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0.25, flex: 1 }}>
                                                                {[1, 2, 3, 4, 5, 6].map((i) => (
                                                                    <Box key={i} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                                        <LocalFireDepartmentIcon sx={{ color: '#BBF3FC', fontSize: 12 }} />
                                                                        <Typography sx={{ color: '#a2aab4', fontSize: 9, lineHeight: 1 }}>{lect[`temperatura${i}`] ?? '-'}</Typography>
                                                                    </Box>
                                                                ))}
                                                            </Box>
                                                            {/* Acumulado circular */}
                                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                    <TrendingUp sx={{ color: '#B8F1FF', fontSize: 16, flexShrink: 0 }} />
                                                                    <CircleProgress
                                                                        value={acumuladoRPM8 ?? 0}
                                                                        min={0}
                                                                        max={18000}
                                                                        size={50}
                                                                        strokeWidth={4}
                                                                        bgColor="#222"
                                                                        textColor="#B8F1FF"
                                                                        progressColor="#B8F1FF"
                                                                        displayText={`${Math.round(((acumuladoRPM8 ?? 0) / 18000) * 100)}%`}
                                                                    />
                                                                </Box>
                                                                <Typography sx={{ color: '#B8F1FF', fontSize: 10, lineHeight: 1, mt: 0.5 }}>{acumuladoRPM8 ?? 0}</Typography>
                                                                <Typography sx={{ color: '#706e6eff', fontSize: 9, lineHeight: 1.4 }}>Acum. día</Typography>
                                                            </Box>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            </ExpandableCard>
                                        </Grid>
                                    );
                                }
                                if (['Machine9', 'Machine10', 'Machine11'].includes(data.maquinaId)) {
                                    return null;
                                }
                                return (
                                    <Grid item xs={6} key={data.maquinaId}>
                                        <ExpandableCard modalWidth={{ xs: '45vw', md: '20vw' }} modalHeight={{ xs: '45vw', md: '20vw' }}>
                                            <Card sx={{ backgroundColor: theme.cardBg, color: theme.text, minHeight: { xs: 180, sm: 230 }, height: '100%', display: 'flex', flexDirection: 'column', boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                                                <CardContent sx={{ p: { xs: 0.25, sm: 1 }, pb: { xs: 0.25, sm: 1 }, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                                    <Typography variant="h7" component="div" sx={{ borderBottom: `1px solid ${theme.border}`, pb: 0.5, mb: 0.5, color: theme.text, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <Box component="span" sx={{ fontSize: { xs: '0.6rem', sm: '0.7rem' }, fontWeight: 'bold' }}>{data.maquinaId}</Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, justifyContent: 'center', mr: 1 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                <TrendingUp sx={{ color: '#B8F1FF', fontSize: { xs: 12, sm: 14 } }} />
                                                                <Box component="span" sx={{ fontSize: { xs: '0.6rem', sm: '0.7rem' }, color: '#B8F1FF', ml: 0.25 }}>
                                                                    {Math.round(((lect.rpm || 0) / 35) * 100)}%
                                                                </Box>
                                                            </Box>
                                                            {/* Icono de humedad con valor */}
                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                                <Opacity sx={{ ...humIconSx, fontSize: 12 }} />
                                                                <Box component="span" sx={{ fontSize: { xs: '0.6rem', sm: '0.7rem' }, ml: 0.25, ...humTextStyle }}>{(lect.humedad !== undefined && lect.humedad !== null) ? `${lect.humedad}%` : '-'}</Box>
                                                            </Box>
                                                        </Box>
                                                    </Typography>
                                                    {hasLecturas ? (
                                                        <Box sx={{ mt: 1 }}>
                                                            <Grid container spacing={1}>
                                                                <Grid item xs={6}>
                                                                    <Box sx={{ height: { xs: 72, sm: 88 }, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#a2aab4', border: `1px solid ${theme.borderCard}`, borderRadius: '6px', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, gap: 0.5, p: { xs: 0.5, sm: 0.75 } }}>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <Thermostat sx={{ color: getTempColor(lect.temperatura, params), fontSize: { xs: 18, sm: 20 }, flexShrink: 0 }} />
                                                                            <CircleProgress value={Number(lect.temperatura) || 0} min={params.minTemp} max={params.maxTemp} size={50} strokeWidth={4} bgColor="transparent" textColor="#a2aab4" progressColor="#B8F1FF" displayText={`${Number(lect.temperatura) || 0}°C`} />
                                                                        </Box>
                                                                        <Typography sx={{ color: '#706e6eff', fontSize: 9, lineHeight: 1.4 }}>Humedad</Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Box sx={{ height: { xs: 72, sm: 88 }, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#a2aab4', border: `1px solid ${theme.borderCard}`, borderRadius: '6px', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, gap: 0.5, p: { xs: 0.5, sm: 0.75 } }}>
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <FlashOn sx={{ color: getAmpColor(lect.amperaje, params), fontSize: { xs: 18, sm: 20 }, flexShrink: 0 }} />
                                                                            <CircleProgress value={Number(lect.amperaje) || 0} min={0} max={40} size={50} strokeWidth={4} bgColor="transparent" textColor="#a2aab4" progressColor="#B8F1FF" displayText={`${Number(lect.amperaje) || 0}A`} />
                                                                        </Box>
                                                                        <Typography sx={{ color: '#706e6eff', fontSize: 9, lineHeight: 1.4 }}>Amperaje</Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    ) : (
                                                        <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <Box sx={{ textAlign: 'center' }}>
                                                                <Typography variant="h6" sx={{ color: '#adababff' }}>Sin datos - {data.maquinaId}</Typography>
                                                                {machineLastUpdates[data.maquinaId] ? (
                                                                    <Typography variant="caption" sx={{ color: '#7f7f7f', display: 'block', mt: 0.5 }}>
                                                                        {`(última: ${formatHour(machineLastUpdates[data.maquinaId])})`}
                                                                    </Typography>
                                                                ) : null}
                                                            </Box>
                                                        </Box>
                                                    )}
                                                    {/* Franja inferior: RPM + Acumulado */}
                                                    <Box sx={{ width: '100%', borderTop: `1px solid ${theme.borderCard}`, pt: 0.5, mt: 1 }}>
                                                        <Grid container spacing={1}>
                                                            {/* RPM */}
                                                            <Grid item xs={6}>
                                                                <Box sx={{ height: { xs: 72, sm: 88 }, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: `1px solid ${theme.borderCard}`, borderRadius: '6px', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, gap: 0.5, p: { xs: 0.5, sm: 0.75 } }}>
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                        <Speed sx={{ color: getRpmArcColor(lect.rpm, params), fontSize: { xs: 18, sm: 20 }, flexShrink: 0 }} />
                                                                        <CircleProgress
                                                                            value={Number(lect.rpm) || 0}
                                                                            min={0}
                                                                            max={params.maxRpm || 40}
                                                                            size={50}
                                                                            strokeWidth={4}
                                                                            bgColor="transparent"
                                                                            textColor="#B8F1FF"
                                                                            progressColor={Number(lect.rpm) > 0 ? getRpmArcColor(lect.rpm, params) : 'transparent'}
                                                                            displayText={`${Number(lect.rpm) || 0}`}
                                                                        />
                                                                    </Box>
                                                                    <Typography sx={{ color: theme.textMuted, fontSize: 9, lineHeight: 1.4 }}>RPM</Typography>
                                                                </Box>
                                                            </Grid>
                                                            {/* Acumulado */}
                                                            <Grid item xs={6}>
                                                                <Box sx={{ height: { xs: 72, sm: 88 }, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', border: `1px solid ${theme.borderCard}`, borderRadius: '6px', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, gap: 0.5, p: { xs: 0.5, sm: 0.75 } }}>
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                        <TrendingUp sx={{ color: '#B8F1FF', fontSize: { xs: 18, sm: 20 }, flexShrink: 0 }} />
                                                                        <CircleProgress
                                                                            value={acumuladoDiaMaquina ?? 0}
                                                                            min={0}
                                                                            max={50000}
                                                                            size={50}
                                                                            strokeWidth={4}
                                                                            bgColor="transparent"
                                                                            textColor="#B8F1FF"
                                                                            progressColor={acumuladoDiaMaquina ? '#B8F1FF' : '#555'}
                                                                            displayText={acumuladoDiaMaquina ? `${Math.round(((acumuladoDiaMaquina ?? 0) / 50000) * 100)}%` : '-'}
                                                                        />
                                                                    </Box>
                                                                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 0.5 }}>
                                                                        <Typography sx={{ color: '#B8F1FF', fontSize: 10, lineHeight: 1 }}>{Math.round(acumuladoDiaMaquina ?? 0)}</Typography>
                                                                        <Typography sx={{ color: '#706e6eff', fontSize: 9, lineHeight: 1 }}>Acum. día</Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </ExpandableCard>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>
                    {/* Gráficas de amperaje: en desktop md=3 (relación 1:3), en móvil full width */}
                    <Grid item xs={12} md={5}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <ExpandableCard modalWidth={{ xs: '48vw', md: '35vw' }} modalHeight={{ xs: '25vw', md: '12vw' }}>
                                    <Card sx={{ backgroundColor: theme.cardBg, color: theme.textSub, boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                                        <CardContent sx={{ p: { xs: 0.25, sm: 1 }, pb: { xs: 0.25, sm: 1 } }}>
                                            <Typography
                                                variant="h6"
                                                component="div"
                                                sx={{ pb: 1, mb: 1, color: theme.textMuted, fontSize: { xs: '0.5rem', sm: '0.75rem', md: '1rem' } }}
                                            >
                                                Gráfica de Amperaje (Máquinas 1-4)
                                            </Typography>
                                            <Box sx={{ height: { xs: '220px', md: '260px' }, backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}`, p: 1 }}>
                                                <LineChart />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </ExpandableCard>
                            </Grid>
                            <Grid item xs={12}>
                                <ExpandableCard modalWidth={{ xs: '48vw', md: '35vw' }} modalHeight={{ xs: '25vw', md: '12vw' }}>
                                    <Card sx={{ backgroundColor: theme.cardBg, color: theme.textSub, boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                                        <CardContent sx={{ p: { xs: 0.25, sm: 1 }, pb: { xs: 0.25, sm: 1 } }}>
                                            <Typography
                                                variant="h6"
                                                component="div"
                                                sx={{ pb: 1, mb: 1, color: theme.textMuted, fontSize: { xs: '0.5rem', sm: '0.75rem', md: '1rem' } }}
                                            >
                                                Gráfica de Amperaje (Máquinas 5-8)
                                            </Typography>
                                            <Box sx={{ height: { xs: '220px', md: '260px' }, backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}`, p: 1 }}>
                                                <LineChart2 />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </ExpandableCard>
                            </Grid>
                            <Grid item xs={12}>
                                <ExpandableCard modalWidth={{ xs: '48vw', md: '35vw' }} modalHeight={{ xs: '25vw', md: '12vw' }}>
                                    <Card sx={{ backgroundColor: theme.cardBg, color: theme.textSub, boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                                        <CardContent sx={{ p: { xs: 0.25, sm: 1 }, pb: { xs: 0.25, sm: 1 } }}>
                                            <Typography
                                                variant="h6"
                                                component="div"
                                                sx={{ pb: 1, mb: 1, color: theme.textMuted, fontSize: { xs: '0.5rem', sm: '0.75rem', md: '1rem' } }}
                                            >
                                                Gráfica de Amperaje (Máquinas 9-11)
                                            </Typography>
                                            <Box sx={{ height: { xs: '220px', md: '260px' }, backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}`, p: 1 }}>
                                                <LineChart3 />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </ExpandableCard>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Metros por Referencia (donas por turno) - columna 3 fila 1 */}
                    <Grid item xs={12} md={3} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                            <DonutMetrosPorTurno darkMode={darkMode} />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1, p: 1 }}>
                            <Box component="img" src="/digitalCaratula.webp" alt="Digital Carátula" sx={{ width: '100%', maxHeight: { xs: '100px', md: '160px' }, objectFit: 'contain' }} />
                        </Box>
                    </Grid>
                    {/* Machine9 / Machine10 / Machine11 - fila completa al 100% del container padre */}
                    <Grid item xs={12}>
                        <Grid container spacing={{ xs: 1, sm: 2 }}>
                            {/* Machine9 */}
                            <Grid item xs={12} sm={4}>
                                <ExpandableCard>
                                    <Card sx={{ backgroundColor: theme.cardBg, color: theme.text, minHeight: 280, mb: { xs: 0.25, sm: 1 }, height: '100%', display: 'flex', flexDirection: 'column', boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                                        <CardContent sx={{ p: { xs: 0.25, sm: 2 }, pb: { xs: 0.25, sm: 2 }, flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="h7" component="div" sx={{ borderBottom: `1px solid ${theme.border}`, pb: 1, mb: 1, color: theme.text, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, fontWeight: 'bold' }}>Machine9</Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flex: 1, justifyContent: 'center' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FlashOn sx={{ color: '#FFD700', fontSize: { xs: 18, sm: 22 } }} />
                                                        <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, color: '#d5d6d6ff', ml: 0.5 }}>
                                                            {amperajesRealTime.Machine9 !== null ? `${amperajesRealTime.Machine9}A` : ((machineMap['Machine9']?.lecturas?.[0]?.amperaje) !== undefined ? `${machineMap['Machine9'].lecturas[0].amperaje}A` : '-')}
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Thermostat sx={{ color: '#545557ff', fontSize: { xs: 18, sm: 22 } }} />
                                                        <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, color: '#d5d6d6ff', ml: 0.5 }}>
                                                            {temperaturasRealTime.Machine9 !== null ? `${temperaturasRealTime.Machine9}°C` : ((machineMap['Machine9']?.lecturas?.[0]?.temperatura1) !== undefined ? `${machineMap['Machine9'].lecturas[0].temperatura1}°C` : '-')}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Typography>
                                            <Box sx={{ flex: 1, width: '100%', height: 0, minHeight: 200, maxHeight: 220, overflow: 'hidden', position: 'relative', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}` }}>
                                                <GraficaTemperaturaMachine9 socket={socket} />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </ExpandableCard>
                            </Grid>
                            {/* Machine10 */}
                            <Grid item xs={12} sm={4}>
                                <ExpandableCard>
                                    <Card sx={{ backgroundColor: theme.cardBg, color: theme.text, minHeight: 280, mb: { xs: 0.25, sm: 1 }, height: '100%', display: 'flex', flexDirection: 'column', boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                                        <CardContent sx={{ p: { xs: 0.25, sm: 2 }, pb: { xs: 0.25, sm: 2 }, flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="h7" component="div" sx={{ borderBottom: `1px solid ${theme.border}`, pb: 1, mb: 1, color: theme.text, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, fontWeight: 'bold' }}>Machine10</Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flex: 1, justifyContent: 'center' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FlashOn sx={{ color: '#FFD700', fontSize: { xs: 18, sm: 22 } }} />
                                                        <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, color: '#d5d6d6ff', ml: 0.5 }}>
                                                            {amperajesRealTime.Machine10 !== null ? `${amperajesRealTime.Machine10}A` : ((machineMap['Machine10']?.lecturas?.[0]?.amperaje) !== undefined ? `${machineMap['Machine10'].lecturas[0].amperaje}A` : '-')}
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Thermostat sx={{ color: '#545557ff', fontSize: { xs: 18, sm: 22 } }} />
                                                        <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, color: '#d5d6d6ff', ml: 0.5 }}>
                                                            {temperaturasRealTime.Machine10 !== null ? `${temperaturasRealTime.Machine10}°C` : ((machineMap['Machine10']?.lecturas?.[0]?.temperatura1) !== undefined ? `${machineMap['Machine10'].lecturas[0].temperatura1}°C` : '-')}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Typography>
                                            <Box sx={{ flex: 1, width: '100%', height: 0, minHeight: 200, maxHeight: 220, overflow: 'hidden', position: 'relative', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}` }}>
                                                <GraficaTemperaturaMachine10 socket={socket} />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </ExpandableCard>
                            </Grid>
                            {/* Machine11 */}
                            <Grid item xs={12} sm={4}>
                                <ExpandableCard>
                                    <Card sx={{ backgroundColor: theme.cardBg, color: theme.text, minHeight: 280, mb: { xs: 0.25, sm: 1 }, height: '100%', display: 'flex', flexDirection: 'column', boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                                        <CardContent sx={{ p: { xs: 0.25, sm: 2 }, pb: { xs: 0.25, sm: 2 }, flex: 1, display: 'flex', flexDirection: 'column' }}>
                                            <Typography variant="h7" component="div" sx={{ borderBottom: `1px solid ${theme.border}`, pb: 1, mb: 1, color: theme.text, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, fontWeight: 'bold' }}>Machine11</Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flex: 1, justifyContent: 'center' }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <FlashOn sx={{ color: '#FFD700', fontSize: { xs: 18, sm: 22 } }} />
                                                        <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, color: '#d5d6d6ff', ml: 0.5 }}>
                                                            {amperajesRealTime.Machine11 !== null ? `${amperajesRealTime.Machine11}A` : ((machineMap['Machine11']?.lecturas?.[0]?.amperaje) !== undefined ? `${machineMap['Machine11'].lecturas[0].amperaje}A` : '-')}
                                                        </Box>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Thermostat sx={{ color: '#545557ff', fontSize: { xs: 18, sm: 22 } }} />
                                                        <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, color: '#d5d6d6ff', ml: 0.5 }}>
                                                            {temperaturasRealTime.Machine11 !== null ? `${temperaturasRealTime.Machine11}°C` : ((machineMap['Machine11']?.lecturas?.[0]?.temperatura1) !== undefined ? `${machineMap['Machine11'].lecturas[0].temperatura1}°C` : '-')}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Typography>
                                            <Box sx={{ flex: 1, width: '100%', height: 0, minHeight: 200, maxHeight: 220, overflow: 'hidden', position: 'relative', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}` }}>
                                                <GraficaTemperaturaMachine11 socket={socket} />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </ExpandableCard>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <Grid container spacing={1} sx={{ mt: 1 }}>
                <Grid item xs={12} md={2.4}>
                    <ExpandableCard>
                        <Box sx={{ height: { xs: '260px', md: '280px' }, display: 'flex', justifyContent: 'center', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}`, alignItems: 'center', p: 1 }}>
                            <BarAcumuladoDia />
                        </Box>
                    </ExpandableCard>
                </Grid>
                <Grid item xs={12} md={2.4}>
                    <ExpandableCard>
                        <Box sx={{ height: { xs: '260px', md: '280px' }, display: 'flex', justifyContent: 'center', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}`, alignItems: 'center', p: 1 }}>
                            <AcumuladoMesTable />
                        </Box>
                    </ExpandableCard>
                </Grid>
                <Grid item xs={12} md={2.4}>
                    <ExpandableCard>
                        <Box sx={{ height: { xs: '260px', md: '280px' }, display: 'flex', justifyContent: 'center', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}`, alignItems: 'center', p: 1 }}>
                            <AcumuladoDiaTable />
                        </Box>
                    </ExpandableCard>
                </Grid>
                <Grid item xs={12} md={2.4}>
                    <ExpandableCard>
                        <Box sx={{ height: { xs: '260px', md: '280px' }, width: '100%', display: 'flex', justifyContent: 'center', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}`, alignItems: 'center', p: 1 }}>
                            <BarAcumuladoAnual style={{ width: '100%', height: '100%' }} />
                        </Box>
                    </ExpandableCard>
                </Grid>
                <Grid item xs={12} md={2.4}>
                    <ExpandableCard>
                        <Box sx={{ height: { xs: '260px', md: '280px' }, display: 'flex', flexDirection: 'column', backgroundColor: theme.cardBg2, boxShadow: theme.shadowInset, borderRadius: '8px', border: `1px solid ${theme.borderCard}`, overflow: 'hidden', p: 1 }}>
                            <VelocidadLinealTotal />
                        </Box>
                    </ExpandableCard>
                </Grid>
            </Grid>
            {/* Machine12: tablero de sensores en tiempo real (socket 'mqttMachine12') */}
            <TableroMachine12 socket={socket} theme={theme} darkMode={darkMode} />
        </Container>
    );
};

export default Datos;